// extracted by mini-css-extract-plugin
module.exports = {"btnMenu":"addGpsMenu_btnMenu__3S3PL","icon":"addGpsMenu_icon__3vyGl"};